import { FormControl, FormGroup } from '@angular/forms';
import { SearchModelV2 } from '../search-model-v2';

/**
 * Search model for the roles listing inside a user's permissions view.
 *
 * Converted from the legacy SearchModel. The raw SQL it used to carry:
 *
 *   query:  (q) => q
 *     ? `(hdr.code ILIKE '%q%' OR hdr.name ILIKE '%q%') AND hdr.status!='DELETED'`
 *     : `hdr.status!='DELETED'`
 *   table:  'app_mst_role'
 *   queryCallbacks: {
 *     code: c => `hdr.code ILIKE '%c%'`,
 *     name: n => `hdr.name ILIKE '%n%'`
 *   }
 *
 * The component maps those onto criteria the roles endpoint understands: the
 * keyword onto `search_word` and the two fields onto `code_like` / `name_like`,
 * all of which RoleUow.generateWhereClauseByCriteria applies as bound ILIKEs.
 */
export const UserPermRoleSearchModel: SearchModelV2 = {
    label: {
        code: 'Code',
        name: 'Name'
    },
    dataType: {
        code: 'string',
        name: 'string'
    },

    form: new FormGroup({
        code: new FormControl(),
        name: new FormControl(),
    }),

    options: {
        code: {},
        name: {}
    }
}
